import Image from 'next/image';
import { formatDate } from '@core/utils';
import Link from 'next/link';
import type { PostOrPage } from '@tryghost/content-api';

interface BlogProps {
  blog: PostOrPage;
  readMoreURL?: string;
}

export default function Blog({
  blog: {
    feature_image,
    feature_image_alt,
    title,
    excerpt,
    published_at,
    slug
  },
  readMoreURL
}: BlogProps) {
  return (
    <div className="w-full realtive overflow-hidden rounded-xl border border-solid border-neutral-200 bg-neutral-100">
      {feature_image ? 
        (
        <div className="w-full h-40 relative">
          <Image
            src={feature_image}
            alt={feature_image_alt ? feature_image_alt : 'blog thumbnail'}
            fill
            className="absolute inset-0 object-cover"
          />
        </div>
        ) : (
          <></>
        )}
      <div className="p-4 flex flex-col gap-2.5">
        <Link href={readMoreURL ? readMoreURL : `/brand/blogs/${slug}`}>
        <div className="space-y-1">
          <h6 className="text-base text-neutral-800 font-semibold text-ellipsis line-clamp-1">{title}</h6>
          <span className="text-[14px] text-neutral-600 font-medium">Published: {formatDate(published_at)}</span>
        </div>
        <div className="flex flex-col items-start gap-2">
          <p className="text-sm text-neutral-600 font-medium text-ellipsis line-clamp-2">
            {excerpt}
          </p>
            <button
              type="button"
              className="px-0 text-sm text-brand-500 font-manrope font-medium hover:underline underline-offset-2 hover:cursor-pointer">
              Read More
            </button>
        </div>
        </Link>
      </div>
    </div>
  );
}
